import { Chip, Icon } from '@mui/material';
import { memo } from 'react';
import { ICarrito, estadoGeneralCarrito } from '@/redux/models';
import ChipAviso from './ChipAviso';
import { useTablaCarritoV2Props, ViewAs } from '../../logics/useTablaCarritoV2';
import { modalCarpetaType } from '../Modals';


const getColorByEstadoCarrito = (estado: estadoGeneralCarrito): any => {
    let color = '#66bb6a'

    switch (estado) {
        case estadoGeneralCarrito['Pendiente']:
            color = '#c59236'
            break;
        case estadoGeneralCarrito['En proceso']:
            color = '#883a3a'
            break;
        case estadoGeneralCarrito['Informada']:
            color = '#518484'
            break;
    }

    return color
}

const TableCarpetaEstados = ({ carpeta, hayRechazados, setModal, viewAs }: { carpeta: ICarrito, hayRechazados: boolean, setModal: useTablaCarritoV2Props['setModal'], viewAs: useTablaCarritoV2Props['viewAs'] }) => {



    return (<>
        {carpeta.observedReason && viewAs === ViewAs.ADMIN && <ChipAviso onClick={() => setModal(modalCarpetaType.VER_NOTAS_CARPETA, carpeta)} />}


        <Chip
            size="small"
            label={estadoGeneralCarrito[carpeta.estadoGeneral]}
            sx={{ backgroundColor: getColorByEstadoCarrito(carpeta.estadoGeneral), m: '2px', color: 'white' }}
            
        />
        <Chip
            icon={<Icon sx={{ color: 'white !important' }}>get_app</Icon>}
            sx={(theme) => ({
                display: carpeta.pdfLiquidacion ? 'flex' : 'none',
                m: '2px',
                color: theme.palette.success.contrastText, backgroundColor: theme.palette.mode === 'dark' ? '#615bd6' : '#4b45b9d9',
                cursor: 'pointer',
                ':hover': {
                    backgroundColor: '#3b386b',
                    color: 'white'
                }
            })}
            size="small"
            label={'Liquidado'}
            onClick={() => window.open(carpeta.pdfLiquidacion, "_blank")}
        />
        {viewAs === ViewAs.ADMIN && <Chip
            icon={<Icon sx={{ color: 'white !important' }}>get_app</Icon>}
            sx={(theme) => ({
                display: carpeta?.liquidacionMensual && !carpeta?.pagado ? 'flex' : 'none',
                m: '2px',
                color: theme.palette.success.contrastText, backgroundColor: theme.palette.mode === 'dark' ? '#ba2abed9' : '#ba2abed9',
                cursor: 'pointer',
                ':hover': {
                    backgroundColor: '#461248d9',
                    color: 'white'
                }
            })}
            size="small"
            label='LM'
            onClick={() => window.open(carpeta?.liquidacionMensual, "_blank")}
        />}
        <Chip
            sx={{
                m: '2px', backgroundColor: '#98ceca', display: carpeta.pagado ? 'flex' : 'none'
            }}
            size="small"
            label='Pagado'
        />

        <Chip
            icon={<Icon sx={{ color: 'white !important' }}>get_app</Icon>}
            sx={{
                display: carpeta?.facturaAdjunta ? 'flex' : 'none',
                m: '2px',
                backgroundColor: '#01caca',
                color: 'white',
                '&:hover': {
                    backgroundColor: '#108181ed',
                    color: 'white'
                }
            }}
            size="small"
            label='Facturado'
            onClick={() => {
                window.open(carpeta?.facturaAdjunta, "_blank")
            }}
        />

        {hayRechazados && (
            <Chip
                sx={{
                    m: '2px', backgroundColor: '#ff0000', color: 'white',
                }}
                size="small"
                label="Rechazado"
            />
        )}

    </>);
}

export default memo(TableCarpetaEstados, (prev, next) => {
    return prev.carpeta.estadoGeneral === next.carpeta.estadoGeneral &&
        prev.carpeta.pdfLiquidacion === next.carpeta.pdfLiquidacion &&
        prev.carpeta.liquidacionMensual === next.carpeta.liquidacionMensual &&
        prev.carpeta.pagado === next.carpeta.pagado &&
        prev.carpeta.facturaAdjunta === next.carpeta.facturaAdjunta &&
        prev.carpeta.observed === next.carpeta.observed &&
        prev.hayRechazados === next.hayRechazados &&
        prev.viewAs === next.viewAs
});